import events from '../events/events';

const Widget = {};

/**
 * Widget plugin
 *
 * @param Vue
 * @param options
 */
Widget.install = function(Vue, options)
{
    let plugin =
    {
        inactive: false,

        /**
         * Open widget by given name
         *
         * @param name
         * @param args
         */
        open(name, args, dismissable)
        {
            plugin.inactive = false;
            events.$emit('widget.open', name, args, dismissable);
        },

        /**
         * Hide widget. Widget does not get removed from dom
         */
        deactivate()
        {
            plugin.inactive = true;
            events.$emit('widget.deactivate');
        },

        /**
         * Show widget.
         */
        activate()
        {
            plugin.inactive = false;
            events.$emit('widget.activate');
        },

        /**
         * External close method
         */
        close()
        {
            plugin.inactive = false;
            events.$emit('widget.close');
        },
    };

    // register plugin globally
    Vue.widget = plugin;
    Vue.prototype.$widget = plugin;
};

export default Widget;



// WEBPACK FOOTER //
// ./src/js/plugins/widget.js